import { render, staticRenderFns } from "./OnlinePaymentTopup.vue?vue&type=template&id=070b04b5&scoped=true&"
import script from "./OnlinePaymentTopup.vue?vue&type=script&lang=js&"
export * from "./OnlinePaymentTopup.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePaymentTopup.vue?vue&type=style&index=0&id=070b04b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070b04b5",
  null
  
)

export default component.exports